import React from "react";
import PropTypes from 'prop-types';
import "./boxDotSkeleton.scss";
function URboxSkeleton(props: any) {
  let {className } = props;
  return (
    <>
      <div className={className}><span className="roundDot"></span></div>
    </>

  );
}

export {
  URboxSkeleton
};

URboxSkeleton.propTypes = {
  className: PropTypes.any,
  profileInfo: PropTypes.any
};